exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "header#header .smart-style-3 .dropdown-menu > li:hover{\r\n    background-color: #f0f3f5 !important;\r\n    color: #181b1e !important;\r\n}\r\nheader#header .smart-style-3 .dropdown-menu > li> a:hover{\r\n    background-color: #f0f3f5 !important;\r\n    color: #181b1e !important;\r\n}\r\n\r\nheader#header .dropdown-menu>li>a {\r\n    display: block;\r\n     t-weight: 400;\r\n    line-height: 1.42857143;\r\n    color: #333;\r\n    white-space: nowrap;\r\n}\r\n\r\nheader#header .dropdown-menu{\r\n    left: -32px !important;\r\n    padding: 0 !important;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/layout/header/header.component.css
// module id = ../../../../../src/app/layout/header/header.component.css
// module chunks = main